<template>
  <div>
    <div class="flex justify-end">
      <div class="w-48 mr-4">
        <a-input
          v-model:value="params.keyword"
          :placeholder="'keyword'"
          testek="search-input"
          @keydown="handleKeyDownInput"
        >
          <template #addonAfter>
            <SearchOutlined />
          </template>
        </a-input>
      </div>
      <div class="btn-add font-bold">
        <a-button
          type="primary"
          testek="btn-add"
          @click="addData"
          :height="32"
          class="flex items-center"
        >
          <template #icon>
            <PlusCircleOutlined />
          </template>
          {{ $t("i18nCommon.AddUser") }}
        </a-button>
      </div>
    </div>
    <BaseList
      :columns="columns"
      :data="TotalInfo && TotalInfo.rows ? TotalInfo.rows : []"
      :pagination="
        TotalInfo
          ? {
              total: TotalInfo.count,
              current: TotalInfo.page,
              pageSize: TotalInfo.limit,
            }
          : {}
      "
      :isShowFiler="false"
      :isShowPrint="false"
      :isShowExport="false"
      :scroll="{ y: 'calc(100vh - 480px)' }"
      @change="handleTableChange"
      @loadDataFilter="loadDataFilter"
    >
      <template #rightWidget="{ record }">
        <div class="flex">
          <div
            class="icon-24 mr-4 cursor-pointer btn-edit flex items-center justify-center"
            @click="editRow(record)"
            :title="$t('i18nCommon.Edit')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-edit icon-16"
            >
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
          </div>
          <div
            class="btn-delete icon-24 mr-4 cursor-pointer flex items-center justify-center"
            @click="deleteRow(record)"
            :title="$t('i18nCommon.Delete')"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              class="feather feather-x icon-16"
            >
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </div>
          <div
            class="icon-24 icon-add-group cursor-pointer"
            @click="addGroup(record)"
            :title="$t('i18nCommon.AddGroup')"
          ></div>
        </div>
      </template>
    </BaseList>
    <div v-if="isShow">
      <a-modal
        v-model:open="isShow"
        centered
        :width="400"
        :ok-text="$t('i18nCommon.Confirm')"
        :cancel-text="$t('i18nCommon.Cancel')"
        @ok="handleOk"
      >
        <div class="header-detail flex justify-between mb-6">
          <div class="font-bold text-xl">
            {{ $t("i18nCommon.AddToGroup") }}
          </div>
        </div>
        <div class="content mt-6">
          <a-form
            ref="ruleFormRef"
            :model="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
            :size="formSize"
            status-icon
            :rules="rules"
          >
            <a-form-item prop="groupId" testek="groupId" class="w-full mr-8">
              <div class="flex min-w-32 font-bold mb-3">
                {{ $t("i18nCommon.SelectGroup") }}
              </div>
              <a-select
                class="w-full"
                v-model:value="ruleForm.groupId"
                show-search
                :placeholder="$t('i18nCommon.Group')"
                :options="Groups"
                :filterOption="false"
                @focus="loadDataGroup"
                @change="onChangeGroup"
                @search="filterDataGroup"
                :field-names="{
                  label: `groupName`,
                  value: `groupId`,
                }"
                testek="group-combobox"
              ></a-select>
            </a-form-item>
          </a-form>
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
import BaseList from "@/views/base/BaseList.vue";
import { mapActions, mapGetters } from "vuex";
import { ModuleGroup, ModuleUser, ModuleUserGroup } from "@/store/module-const";
import { Modal } from "ant-design-vue";
export default {
  name: "UserList",
  components: {
    BaseList,
  },
  data() {
    return {
      columns: [],
      pagination: {
        total: 200,
        current: 1,
        pageSize: 20,
      },
      params: {
        keyword: "",
      },
      isShow: false,
      ruleForm: {
        groupId: "",
      },
    };
  },
  computed: {
    ...mapGetters(ModuleUser, ["TotalInfo"]),
    ...mapGetters(ModuleGroup, ["Groups"]),
  },
  async created() {
    const me = this;
    me.initDataStatic();
    await me.loadDataGrid();
  },
  methods: {
    ...mapActions(ModuleUser, ["getUsers", "updateUser", "deleteUser"]),
    ...mapActions(ModuleGroup, ["getGroups"]),
    ...mapActions(ModuleUserGroup, ["addUserToGroup"]),
    handleTableChange: _.debounce(async function (page) {
      const me = this;
      me.pagination.current = page.current;
      me.pagination.pageSize = page.pageSize;
      me.pagination.total = page.total;
      await me.loadDataGrid();
    }, 300),
    initDataStatic() {
      const me = this;
      me.columns = [
        {
          fixed: "left",
          title: me.$t("i18nCommon.UserInfo.Code"),
          dataIndex: "userCode",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.userCode, b.userCode),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.UserInfo.Name"),
          dataIndex: "fullName",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.fullName, b.fullName),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.UserInfo.Email"),
          dataIndex: "email",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.email, b.email),
        },
        {
          title: me.$t("i18nCommon.UserInfo.PhoneNumber"),
          dataIndex: "phoneNumber",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.phoneNumber, b.phoneNumber),
          columnKey: "name",
        },
        {
          title: me.$t("i18nCommon.UserInfo.IdentityNumber"),
          dataIndex: "identityNumber",
          sorter: (a, b) => me.$commonFunc.sortColumn(a.phoneNumber, b.phoneNumber),
        },
        {
          title: me.$t("i18nCommon.UserInfo.AccountState"),
          dataIndex: "accountState",
        },
        {
          title: me.$t("i18nCommon.UserInfo.Action"),
          key: "rightWidget",
          fixed: "right",
          width: 150,
        },
      ];
      me.rules = {
        groupId: [
          {
            required: true,
            message: `${me.$t("i18nProduct.GroupInvalid")}`,
            trigger: ["change", "blur"],
          },
        ],
      };
    },

    async loadDataGrid() {
      const me = this;
      let payload = {
        ...me.payload,
        limit: me.pagination.pageSize,
        page: me.pagination.current,
      };
      await me.getUsers(payload);
    },
    loadDataFilter: _.debounce(async function (params) {
      const me = this;
      let payload = {
        ...me.payload,
        ...params,
        limit: me.pagination.pageSize,
        page: me.pagination.current,
      };
      await me.getUsers(payload);
    }, 300),
    addData() {
      const me = this;
      me.$router.push("/create-user");
    },
    menuClick(menu) {
      const me = this;
      me.menuActive = menu;
    },
    editRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) return;

      me.$router.push("/create-user");
      setTimeout(() => {
        me.$emitter.emit("LoadEditUser", {
          id: dataRow.userId,
          mode: me.$enum.Mode.Edit,
        });
      }, 300);
    }, 300),

    deleteRow: _.debounce(async function (dataRow) {
      const me = this;
      if (!dataRow) {
        me.$messageNotification.messageNotification(
          me.$t("i18nCommon.DeleteUserFail"),
          "warning"
        );
        return;
      }

      Modal.confirm({
        title: me.$t("i18nCommon.Confirm"),
        content: me.$t("i18nCommon.DeleteUserConfirm", {
          name: dataRow.username,
        }),
        okText: me.$t("i18nCommon.Yes"),
        cancelText: me.$t("i18nCommon.No"),
        centered: true,
        async onOk() {
          let result = await me.deleteUser({ id: dataRow.userId });
          if (result && result.code) {
            await me.loadDataGrid();
            //Thông báo
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteUserSuccess")
            );
          } else if (result && (result.statusCode == 400 || result.statusCode == 409)) {
            me.$messageNotification.messageNotification(result.message, "warning");
          } else {
            me.$messageNotification.messageNotification(
              me.$t("i18nCommon.DeleteUserFail"),
              "warning"
            );
          }
        },
      });
    }, 300),

    addGroup(dataRow) {
      const me = this;
      me.isShow = true;
      me.ruleForm = {
        userId: dataRow.userId,
        default: false,
        leader: false,
      };
    },

    addDataToGroup: _.debounce(async function (isReset = true) {
      const me = this;
      let result = await me.addUserToGroup(me.ruleForm);
      if (result && result.data) {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddUserToGroupSuccess")
        );
        if (isReset == true) {
          me.ruleForm = {};
        }
        me.isShow = false;
      } else {
        this.$messageNotification.messageNotification(
          me.$t("i18nCommon.AddUserToGroupFail"),
          "warning"
        );
      }
    }, 300),
    async handleOk() {
      const me = this;
      console.log(me.ruleForm);

      let formEl = me.$refs.ruleFormRef;
      if (!formEl) return;

      formEl
        .validate()
        .then(async () => {
          await me.addDataToGroup();
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    async handleTableChange(page) {
      const me = this;
      me.pagination.current = page.current;
      me.pagination.pageSize = page.pageSize;
      me.pagination.total = page.total;
      await me.loadDataGrid();
    },

    handleKeyDownInput(event) {
      //Hỗ trợ key enter
      if (event.keyCode === 13) {
        this.loadDataFilter();
      }
    },

    loadDataFilter: _.debounce(async function (params) {
      const me = this;
      let payload = {
        keyword: me.params.keyword,
        limit: me.pagination.pageSize,
        page: 1,
      };
      await me.getUsers(payload);
    }, 300),

    loadDataGroup: _.debounce(async function () {
      const me = this;
      if (me.Groups && me.Groups.length > 0) return;
      await me.getGroups();
    }, 300),

    filterDataGroup: _.debounce(async function (searchText) {
      const me = this;
      await me.getGroups({
        keyword: searchText,
      });
    }, 500),

    onChangeGroup: _.debounce(function (payload) {
      const me = this;
    }, 500),
  },
};
</script>

<style lang="scss" scoped>
.bg-default {
  background: #737373;
}

.gradient-background {
  background: linear-gradient(45deg, #07074f, #7f4fa2);

  &:hover {
    background: linear-gradient(45deg, #0b0b7e, #955dbd);
  }
}

.btn-edit {
  &:hover {
    background: #0abb87;
    color: #fff;
    border: 1px solid #0abb87;
    border-radius: 50%;
  }
}

.btn-delete {
  &:hover {
    background: #fd1361;
    color: #fff;
    border: 1px solid #fd1361;
    border-radius: 50%;
  }
}
</style>
